module.exports = __webpack_public_path__ + "static/media/scg-icon.0a802143.ttf";